<template>
  <div class="block">
    <kst-number-with-date view-mode
      :catalog="Catalog"
      :data="receiveData"
      dateField="Date"
      numberField="ReceiveNumber"
    />

    <template v-if="receiveData.VendorID">
      <kst-output field="VendorID" :data="receiveData" :catalog="Catalog">
        <template #left>
          <kst-output addons floating-label
            field="VendorAlias" :data="receiveData" :catalog="Catalog"
          />
        </template>
        <template #default>
          <kst-output addons expanded floating-label
            field="VendorName" :data="receiveData" :catalog="Catalog"
          />
        </template>
      </kst-output>
    </template>
    <template v-else>
      <kst-output control-off field="VendorID" :data="receiveData" :catalog="Catalog">
        <kst-output addons expanded floating-label
          field="VendorName" :data="receiveData" :catalog="Catalog"
        />
      </kst-output>
    </template>

    <kst-output field="VendorAddress" :data="receiveData" :catalog="Catalog"/>
    <kst-output field="Comment" :data="receiveData" :catalog="Catalog"/>
    <kst-created :data="receiveData"/>
    <kst-last-updated :data="receiveData"/>
    <kst-output field="WarehouseID" :data="receiveData" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../RcvCatalog.js";

export default {
  props: {
    receiveData: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>